import React from "react";

const About = () => {
  return (
    <footer className='site-footer'>
      <div className='container'>
        <div className='flex flex-col md:flex-row items-center justify-evenly py-10 '>
          <div className=' md:w-1/2'>
            <div className='fontDoHyeon text-3xl'>About VALORANT TRACKER</div>
            <div className='text-white'>
              Valorant Tracker is coming soon!. Valorant Tracker provides
              Valorant stats, guides and tips on how you can improve fast, also
              leaderboards to see where you are ranked globally and of course
              daily news about the game. Valorant Tracker also provides you with
              a complete statistique of your profile including your history,top
              champions and more, you can also join our community in discord to
              be in contact with our expert players. Valorant tracket provides
              all of this and more coming to get you ahead of everyone else.
            </div>
          </div>

          <div class='col-xs-6 col-md-3'>
            <div className='text-2xl'>Quick Links</div>
            <ul class='footer-links text-white'>
              <li>
                <a href='#'>Contact Us</a>
              </li>
              <li>
                <a href='#'>Contribute</a>
              </li>
              <li>
                <a href='#'>Privacy Policy</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr />
      <div class=''>
        <div class='flex-col text-center items-center'>
          <div class=''>
            <p class='px-10'>
              Valorant Trackerendorsed by Riot Games and doesn’t reflect the
              views or opinions of Riot Games or anyone officially involved in
              producing or managing VALORANT. VALORANT and Riot Games are
              trademarks or registered trademarks of Riot Games, Inc. VALORANT ©
              Riot Games, Inc.
            </p>
          </div>

          <div class='col-md-4 col-sm-6 col-xs-12'>
            <ul class='social-icons'>
              <li>
                <a class='facebook' href='#'>
                  <i class='fa fa-facebook'></i>
                </a>
              </li>
              <li>
                <a class='twitter' href='#'>
                  <i class='fa fa-twitter'></i>
                </a>
              </li>
              <li>
                <a class='dribbble' href='#'>
                  <i class='fa fa-dribbble'></i>
                </a>
              </li>
              <li>
                <a class='linkedin' href='#'>
                  <i class='fa fa-linkedin'></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default About;
